import React from 'react';
import {ActiveFilter, IFiltersGroup} from "../../../services/games-filter/games-filter.service.interface";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {GroupFiltersListContainerBox} from "./boxes/group-filters-list-container.box";
import {GroupFiltersListGroupBox} from "./boxes/group-filters-list-group.box";
import {GroupFiltersListGroupTitleBox} from "./boxes/group-filters-list-group-title.box";
import {GroupFiltersListContainerFilterByBox} from "./boxes/group-filters-list-container-filter-by.box";
import {GroupFiltersListGroupTitleActivePreviewBox} from "./boxes/group-filters-list-group-title-active-preview.box";
import {GroupFiltersListGroupTitleContainerBox} from "./boxes/group-filters-list-group-title-container.box";
import {GroupFiltersListGroupFiltersContainerBox} from "./boxes/group-filters-list-group-filters-container.box";
import {GroupFiltersListGroupFilterBox} from "./boxes/group-filters-list-group-filter.box";
import {GroupFiltersListGroupFilterInputBox} from "./boxes/group-filters-list-group-filter-input.box";
import {GroupFiltersListGroupFilterTitleBox} from "./boxes/group-filters-list-group-filter-title.box";

export interface IGroupFiltersListComponentProps {
    filtersGroup: IFiltersGroup[];
    onToggle: (filter: ActiveFilter) => void;
}

export interface IGroupFilterComponentProps extends IFiltersGroup {
    onFilterToggle: (filter: ActiveFilter) => void;
    onGroupToggle: (filtersGroupText: string) => void;
    isOpen: boolean;
}

class GroupFilterComponent extends OrbitComponent<IGroupFilterComponentProps> {
    render() {
        const {isOpen, onGroupToggle, onFilterToggle, isMultiSelect, text: groupTitle, filters} = this.props;

        const activeFiltersTexts = filters.filter(f => f.on).map(f => f.text);
        const inputType = isMultiSelect ? 'checkbox' : 'radio';

        return (
            <GroupFiltersListGroupBox>
                <GroupFiltersListGroupTitleContainerBox onClick={() => onGroupToggle(groupTitle)}>
                    <GroupFiltersListGroupTitleBox isOpen={isOpen}>{this.services.translation.translate(groupTitle)}</GroupFiltersListGroupTitleBox>

                    <GroupFiltersListGroupTitleActivePreviewBox isVisible={!isOpen && activeFiltersTexts.length > 0}>
                        {activeFiltersTexts.join(', ')}
                    </GroupFiltersListGroupTitleActivePreviewBox>
                </GroupFiltersListGroupTitleContainerBox>

                <GroupFiltersListGroupFiltersContainerBox isOpen={isOpen}>
                    {filters.map(filter => (
                        <GroupFiltersListGroupFilterBox onClick={() => onFilterToggle(filter)}>
                            <GroupFiltersListGroupFilterInputBox type={inputType} name={`${groupTitle}-option`} checked={!!filter.on}/>
                            <GroupFiltersListGroupFilterTitleBox className="filter-title" amount={10}>{filter.text}</GroupFiltersListGroupFilterTitleBox>
                        </GroupFiltersListGroupFilterBox>
                    ))}
                </GroupFiltersListGroupFiltersContainerBox>
            </GroupFiltersListGroupBox>
        )
    }
}

export class GroupFiltersListComponent extends OrbitComponent<IGroupFiltersListComponentProps> {

    state = {
        currentOpenFilterGroupText: null
    }

    onFilterGroupClicked(filtersGroupText: string) {
        this.setState({currentOpenFilterGroupText: filtersGroupText !== this.state.currentOpenFilterGroupText ? filtersGroupText : null});
    }

    render() {
        return (
            <GroupFiltersListContainerBox>
                <GroupFiltersListContainerFilterByBox>Filter By</GroupFiltersListContainerFilterByBox>

                {this.props.filtersGroup.map(group =>
                    <GroupFilterComponent
                        {...group}
                        onGroupToggle={this.onFilterGroupClicked.bind(this)}
                        onFilterToggle={this.props.onToggle}
                        isOpen={this.state.currentOpenFilterGroupText === group.text}
                    />)}
            </GroupFiltersListContainerBox>
        )
    }
}